if (typeof console === "undefined") {
    var console = {};
}
if (!console.log) {
    console.log = function() {};
}
var domReady = function(callback) {
	"use strict";
	if (document.readyState === "interactive" || document.readyState === "complete") {
		callback();
	} else {
		document.addEventListener("DOMContentLoaded", callback);
	}
};


YUI().use("subset-search", "event-move", function(Y) {

    "use strict";

    var $ = Y.one,
		homenav,
        searchform;

      /**
       * Handle a click on a link inside a header menu.
       *
       */
      var clickHeaderLink = function(evt) {
   	   console.log(evt);
   	   var target = evt.target;

   		try {
   		  	ga('send', 'event', 'Header menu', 'click', target.getAttribute('href'), {nonInteraction:1});
   		} catch (ex) {}

      };


    homenav = $('.ksu-home-nav');
	if (homenav) {
		homenav.delegate("click", clickHeaderLink, "a");
	}

    /*
     * Add subset search fields to the form.
     */
    searchform = $("#ksu-search");
    if (searchform) {
        searchform.plug(Y.Plugin.SubsetSearch);
    }

});


domReady(function() {

	"use strict";

	var $ = document.querySelector.bind(document),
		signincontainer,
	    signinbar,
		signinlabel,
		signinoverlayvisible = false,
		desrc,
		detarget;

	var whichTransitionEvent = function() {
    	var t,
    		el = document.createElement('fakeelement'),
    		transitions = {
      			'transition':'transitionend',
      			'OTransition':'oTransitionEnd',
      			'MozTransition':'transitionend',
      			'WebkitTransition':'webkitTransitionEnd'
    		};

    	for (t in transitions){
        	if (el.style[t] !== undefined) {
            	return transitions[t];
        	}
    	}
	};

	/*
     * Toggles the appearance of the signin box.
     */
   	var openSignin = function(evt) {
		console.log("openSignin");

        signincontainer.classList.add("ksu-open");
        signincontainer.classList.add("ksu-opening");
		signinbar.style.right = '0';

      /*
       * The signin link is coded as a link to signin.k-state.edu so those who have JavaScript turned off end up on the
       * SSO page. The normal people with JavaScript enabled don't want to follow the link, so prevent the normal
       * browser behavior.
       */
		if (evt) {
			evt.preventDefault();
		}

		try {
			if (!signinoverlayvisible) {
		  		ga('send', 'event', 'Signin', 'open', {nonInteraction:1});
			}
		} catch (ex) {}
      	signinoverlayvisible = true;
   };


   	/**
     * Set the right attribute of the absolutely-positioned ksu-signin-bar element.
	 * This has to be done in JavaScript because:
	 *   1. The font widths change between Windows and Mac.
	 *   2. The font widths change when the dynamic font is loaded.
	 *   3. The width of the ksu-signin-bar element changes when the window
	 *      is narrow and the bar becomes vertical rather than horizontal.
     */
	var styleSigninClosed = function() {

		var signinbarwidth = signinbar.offsetWidth;

		if (signinbarwidth < 200) {
			signinbarwidth = 500;
		}
		signinbar.style.right = (-signinbarwidth) + "px";
	};


	/**
	 * Toggles the appearance of the signin box.
	 */
	var closeSignin = function(evt) {
		//console.log("closeSignin");

		if (!signinoverlayvisible) {
			return;
		}

		signincontainer.classList.remove("ksu-open");
		signincontainer.classList.add("ksu-closing");

		styleSigninClosed();

		if (evt) {
			evt.preventDefault();
		}
		try {
		  	if (signinoverlayvisible) {
				ga('send', 'event', 'Signin', 'close', {nonInteraction:1});
			}
		} catch (ex) {}
      	signinoverlayvisible = false;
   };

   /**
    * Handle a click on a link inside the signin block.
    *
    * This function just logs the event in Google Analytics and then lets the browser follow the link.
    */
   var clickSignin = function(evt) {
	   //console.log("clicksignin", evt);
	   var target = evt.target,
	       href;

	   try {
		   if (target.classList.contains('ksu-signin-close') || target.classList.contains('ksu-signin-close-port')) {
			   closeSignin(evt);
			   return;
		   }
	   } catch(e) {}

		try {
			href = target.getAttribute("href");
			if (href) {
		  		ga('send', 'event', 'Signin', 'click', href, {nonInteraction:1});
			}
		} catch (ex) {}

   };


    /**
     * Handle click events on the document body.
     *
     * In general, clicks outside of any sensitive area turn off the header submenu
     * and the signin box.
     */
    var clickBody = function(evt) {
        var target = evt.target,
            inside_signin;
        //console.log("Body click");

        /*
         * If the signin box is visible, and the click wasn't inside the signin form,
         * then turn the signin form off.
         */
        inside_signin = signincontainer && signincontainer.contains(target);
        if (!inside_signin) {
            closeSignin();
        }
    };

	var endTransition = function() {
		//console.log("endTransition", evt);
		signincontainer.classList.remove("ksu-opening");
		signincontainer.classList.remove("ksu-closing");
	};

	signincontainer = $(".ksu-signin-container");

	if (signincontainer) {
		signinbar = signincontainer.querySelector("div");
		signinlabel = signincontainer.querySelector(".ksu-signin-label");

		styleSigninClosed();

    	/*
     	 * Add event handlers for the functional parts of the page.
    	 */
		signinlabel.addEventListener("click", openSignin);
    	$("body").addEventListener("click", clickBody);
    	signinbar.addEventListener("click", clickSignin);
		signincontainer.addEventListener(whichTransitionEvent(), endTransition, true);
	}

	/* Copy the direct edit URL to the visible direct edit link */
	try {
		desrc = document.querySelector("#ksu-de-src a");
		detarget = document.querySelector("#ksu-de-target");
		if (desrc && detarget) {
			detarget.href = desrc.href;
			var newest = 0;
			if (KSU.dates) {
				KSU.dates.forEach(function(d) {
				   	d = new Date(d);
				   	var dt = d.getTime();
				   	if (dt > newest) {
					   	newest = dt;
				   	}
				});

				// If there was at least one valid date in the dates array, then newest
				// contains the most recent.
				if (newest) {
					newest = new Date(newest);
					detarget.innerHTML = "Updated " + (newest.getMonth()+1) + "/" + newest.getDate() + "/" + newest.getFullYear();
				}


				if (!KSU.dates || !newest) {
					// This is a page that hasn't been recently published.
					// Copy the text of the old-style DE link.
					detarget.innerHTML = desrc.innerHTML;
				}
			}
		}
	} catch (e) {
		// Nothing -- the direct edit link will just be unchanged.
	}
});
